/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtractRequest
 */
export interface ExtractRequest {
    /**
     * 
     * @type {number}
     * @memberof ExtractRequest
     */
    stream: number;
    /**
     * 
     * @type {string}
     * @memberof ExtractRequest
     */
    destination: string;
}

export function ExtractRequestFromJSON(json: any): ExtractRequest {
    return ExtractRequestFromJSONTyped(json, false);
}

export function ExtractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stream': json['stream'],
        'destination': json['destination'],
    };
}

export function ExtractRequestToJSON(value?: ExtractRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stream': value.stream,
        'destination': value.destination,
    };
}


